import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Autoridades.css";
import {
  FaUserTie,
  FaUser,
  FaEnvelope,
  FaSitemap,
} from "react-icons/fa"; //  Íconos agregados

// Fotos de Autoridades 
import perfil from "../assets/nosotros/autoridades/perfil.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";
//import  from "../assets/nosotros/autoridades/.jpg";

const Autoridades = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const autoridades = [
    {
      frase:
        "Listos para responder a los nuevos retos, exigencias y competencias del mercado laboral.",
      nombre: "Sovero Sovero Ledgar Nicolao",
      cargo: "Directora General",
      correo: "lsovero@institucioneducativa.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "OLIVARES MANDUJANO MARICELA FRESIA ",
      cargo: "AREA DE ADMINISTRACION",
      correo: "olivares.maricela@iestpgildaballivian.edu.pe ",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "GUTIERREZ BARAHONA JOSE DIOMEDES ",
      cargo: "AREA DE CALIDAD",
      correo: "gutierrez.jose@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "ANTONIO PAZ SOLDAN AMADEO SIXTO",
      cargo: "AREA DE SECRETARIA ACADEMICA",
      correo: "Jantonio.amadeo@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
   
    {
      frase:
        "",
      nombre: "PILLACA DIAZ TEODORO ",
      cargo: "JEFE DE FORMACION CONTINUA",
      correo: "píllaca.teodoro@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "RAMIREZ CHUQUIHUANGA LUIS ALBERTO  ",
      cargo: "JEFE DE INVESTIGACION",
      correo: "ramirez.luis@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "JURADO GUILLEN NOSSER MARIANO   ",
      cargo: "JEFE DE UNIDAD ACADEMICA",
      correo: "jurado.nosser@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "RAZO QUISPE JOSE LUIS  ",
      cargo: "EFE DE UNIDAD DE BIENESTAR Y EMPLEABILIDAD",
      correo: "razo.jose@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
  ];

  const coordinadores = [
     {
      frase:
        "",
      nombre: "AZAHUANCHE ASMAT VIRGINIA LIBERTAD ",
      cargo: "COORD CONSTRUCCION CIVIL",
      correo: "azahuanche.virginia@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "FERNANDEZ CASTRO JORGE MARCELINO ",
      cargo: "COORD CONTABILIDAD",
      correo: "fernandez.jorge@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "MONARES CHAVEZ MAURA BEATRIZ",
      cargo: "COORD DESARROLLO DE SISTEMAS",
      correo: "monares.maura@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "CARHUANCHO PALOMINO LUIS ENRIQUE ",
      cargo: "COORD ELECTRICIDAD INDUSTRIAL",
      correo: "carhuancho.luis@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "ROJAS CAHUA LUIS ALBERTO ",
      cargo: "COORD ELECTRONICA INDUSTRIAL",
      correo: "rojas.luis@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "NEGRON ALVARADO ELMER AUGURIO ",
      cargo: "Cnegron.elmer@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "CALDERON CORNELIO WILMER WASHINGTON ",
      cargo: "COORD MECANICA DE PRODUCCION",
      correo: "calderon.wilmer@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
    {
      frase:
        "",
      nombre: "PALOMARES ANSELMO JIM ANDREW ",
      cargo: "COORD MECATRONICA AUTOMOTRIZ",
      correo: "palomares.jim@iestpgildaballivian.edu.pe",
      foto: perfil,
    },
  ];

  return (
    <section className="autoridades-page">
      <div className="autoridades-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Autoridades</h1>
          <p className="lead">
            Comprometidos con el liderazgo, la innovación y la excelencia educativa.
          </p>
        </div>
      </div>

      <div className="container py-5 text-center">
        <h2 className="section-title mb-4 text-primary">
          Equipo Directivo
        </h2>

        <div className="row g-4 justify-content-center">
          {autoridades.map((a, i) => (
            <div
              className="col-md-6 col-lg-4 d-flex justify-content-center"
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 100}
            >
              <div className="autoridad-card">
                <img src={a.foto} alt={a.nombre} className="autoridad-foto" />
                <div className="autoridad-info text-start">
                    <p className="autoridad-frase">“{a.frase}”</p>
                    <p className="autoridad-linea">
                    <FaUserTie className="autoridad-icon" /> {a.nombre}
                    </p>
                    <p className="autoridad-linea">
                    <FaSitemap className="autoridad-icon" /> {a.cargo}
                    </p>
                    <p className="autoridad-linea">
                    <FaEnvelope className="autoridad-icon" />
                    <a href={`mailto:${a.correo}`} className="autoridad-correo">
                        {a.correo}
                    </a>
                    </p>
                </div>
                </div>

            </div>
          ))}
        </div>

        <h2 className="section-subtitle mt-5 text-primary">
          Coordinadores de Áreas
        </h2>

        <div className="row g-4 justify-content-center mt-3">
          {coordinadores.map((c, i) => (
            <div
              className="col-md-6 col-lg-4 d-flex justify-content-center"
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 100}
            >
              <div className="autoridad-card">
                <img src={c.foto} alt={c.nombre} className="autoridad-foto" />
                <div className="autoridad-info text-start">
                    <p className="autoridad-frase">“{c.frase}”</p>
                    <p className="autoridad-linea">
                    <FaUser className="autoridad-icon" /> {c.nombre}
                    </p>
                    <p className="autoridad-linea">
                    <FaSitemap className="autoridad-icon" /> {c.cargo}
                    </p>
                    <p className="autoridad-linea">
                    <FaEnvelope className="autoridad-icon" />
                    <a href={`mailto:${c.correo}`} className="autoridad-correo">
                        {c.correo}
                    </a>
                    </p>
                </div>
                </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Autoridades;